const img = require('./Portis.svg'); export default img;